/**
 * Primary brand mark served from `client/public/` (build → site root `/`).
 * Transparent circular PNG generated from `public/logo.jpeg` by `npm run brand:logo`.
 */
export const BRAND_LOGO_PUBLIC_PATH = '/logo.png' as const;
